import { ACTIVECART_DRAFTORDER_GET_SUCCESS } from '../actionTypes/ActiveCartReminderActionTypes';

const activeCartDraftOrderReducer = function activeCartDraftOrderReducer(state = {}, action) {
    switch (action.type) {
        case ACTIVECART_DRAFTORDER_GET_SUCCESS:
            return action.cartDraftOrderDetails;
        default:
            return state;
    }
};

activeCartDraftOrderReducer.reducerName = 'activeCartDraftOrder';

export default activeCartDraftOrderReducer;
